
import { get, gets, post, posts } from './server.js'

export const base = 'https://explorer.tfsc.io/tfscBrowser/home/' 
export const base1 = 'https://explorer.tfsc.io/tfscBrowser/user/'//测试
export const base2 = 'https://explorer.tfsc.io'//测试
export const base3 = 'wss://explorer.tfsc.io/tfscBrowser/websocket'//测试
 

// export const base = 'http://192.168.1.123:9200/tfscBrowser/home/'//测试
// export const base1 = 'http://192.168.1.123:9200/tfscBrowser/user/'//测试
// export const base2 = 'http://192.168.1.123:9200'//测试
// export const base3 = 'ws://192.168.1.123:9200'//测试

// export const base = 'http://47.98.110.210:9200/tfscBrowser/home/'//测试
// export const base1 = 'http://47.98.110.210:9200/tfscBrowser/user/'//测试
//export const base2 = 'http://192.168.1.123:6072/chainScanAPI/v1/network/evm/'//测试

//http://192.168.1.123:6072/chainScanAPI/v1/network/evm/

// export const base = 'https://explorer.tfsc.io/tfscBrowser/home/'//线上正式
// export const base1 = 'https://explorer.tfsc.io/tfscBrowser/user/'//测试
export const GetHomeData = p => post(base + 'getHomeData', p);
export const GetHomePastTradeData = p => post(base + 'getHomePastTradeData', p);
export const GetTxList = p => post(base + 'getTxList', p);
//验证器排行榜
export const ValidatorRankList = p => post(base + 'validatorRankList', p);
//区块Hash详情
export const GetblockDetail = p => post(base + 'blockDetail', p);
//高度详情接口
export const GetheightDetail = p => post(base + 'heightDetail', p);
//TFSC交易详情-申领交易type=99
//transactionDetail-Bonus
export const GetheightDetailBonus = p => post(base + 'transactionDetail-Bonus', p);
//TFSC交易详情-普通交易 type=1 transactionDetail-MainNetTransfer
export const GetheightDetailTransfer = p => post(base + 'transactionDetail-MainNetTransfer', p);
//钱包地址详情
export const AddressDetail = p => post(base + 'addressDetail', p);
//钱包地址分栏
export const GetaddressTypeList = p => post(base + 'addressDetailTypeList', p);

//钱包地址分栏taken
export const GettokenList = p => post(base + 'addressDetail-tokenList', p);

//交易详情:合约执行交易详情 合约执行 包括NFT转移 Token转账 mint铸造 当type类型=8的时候 点击交易Hash 跳转 调用
export const ContractTransfer = p => post(base + 'transactionDetail-contractTransfer', p);
//交易详情 合约创建 当type类型=7的时候调用
export const ContractCreate = p => post(base + 'transactionDetail-contractCreate', p);
//NFT Token交易记录
export const ContractTxList = p => post(base + 'contractTxList', p);
//一个NFT详情页面
export const NftItemDetail = p => post(base + 'nftItemDetail', p);
//一类NFT详情页
export const NftDetail = p => post(base + 'nftDetail', p);
//NFT详情页-分栏展示
export const NftDetailColumns = p => post(base + 'nftDetail-Columns', p);
//访问钱包地址持有的NFT列表信息 /addressDetail-nftList
export const AddressDetaillist = p => post(base + 'addressDetail-nftList', p);
//代币详情页面
export const TokenDetail = p => post(base + 'tokenDetail', p);
//代表分栏详情
export const TokenDetailColumns = p => post(base + 'tokenDetail-Columns', p);
//Token合约列表
export const TokenList = p => post(base + 'tokenList', p);
//NFT列表数据页面(nftList)
export const GetnftList = p => post(base + 'nftList', p);
//合约列表接口
export const GetContractList = p => post(base + 'contractList', p);
//搜索开始
export const GetSearchKey = p => post(base + 'searchKey', p);
//合约验证
export const GetvertifyContract = p => post(base + 'vertifyContract', p);
// vertifyContract
//validatorDetail
export const GetvalidatorDetail = p => post(base + 'validatorDetail', p);
//区块列表
export const GetBlockList = p => post(base + 'getBlockList', p);

export const GetDynamicBlock = p => post(base + 'getDynamicBlock', p);
//getHomePastTradeData
// 区块列表
export const BlockList = p => post(base + 'blockList', p);
// 交易列表
export const TradeList = p => post(base + 'tradeList', p);
// 获取签名列表
export const VerifyList = p => post(base + 'verifyList', p);
// 交易详情
export const TransactionDetail = p => post(base + 'transactionDetail', p);
// 区块详情
export const BlockDetail = p => post(base + 'blockDetail', p);
//高度详情
export const HeightDetail = p => post(base + 'heightDetail', p);
//钱包地址
//export const AddressDetail = p => post(base + 'addressDetail', p);
//验证器排行榜
// export const ValidatorRankList = p => post(base + 'validatorRankList', p);
//验证器排行榜详情
export const ValidatorDetail = p => post(base + 'validatorDetail', p);
//搜素栏
export const SearchKey = p => post(base + 'searchKey', p);
//筛选钱包地址交易记录
export const TypeTxsList = p => post(base + 'getAddressTypeTxsList', p);
//charts中的8个列表图
export const GetChartData = p => post(base + 'getChartData', p);

//用户登录
export const login = p => post(base1 + 'login', p);
//用户注册
export const register = p => post(base1 + 'register', p);
//用户激活
export const activateUser = p => post(base1 + 'activateUser', p);
// 重置密码发送验证邮箱
export const sendResetPwdEmail = p => post(base1 + 'sendResetPwdEmail', p);
// 重置密码
export const resetPwd = p => post(base1 + 'resetPwd', p);
// 查看已经验证的合约列表
export const getverifiedContractList = p => post(base1 + 'verifiedContractList', p);
// 输入合约地址初始化
export const initAddVerifiedContract = p => post(base1 + 'initAddVerifiedContract', p);
// 根据签名信息ID获取signatureHash
export const getSignatureHashBySignUUID = p => post(base1 + 'getSignatureHashBySignUUID', p);
// 提交验证合约
export const commitVerifyContract = p => post(base1 + 'commitVerifyContract', p);
// 更新验证过的合约信息
export const updateContractInfo = p => post(base1 + 'updateContractInfo', p);
// 获取合约信息
export const getContractInfo = p => post(base1 + 'getContractInfo', p);
//删除合约列表内容/removeContractVerify
export const removeContractVerify = p => post(base1 + 'removeContractVerify', p);
//apis
export const getaddresses = p => post(base2 + 'addresses', p);
